/**
 * Feature detection helper
 */

export default class Feature {
    static supportsPassive() {
        if (window.passiveListener) {
            return window.passiveListener;
        }

        let supported = false;

        try {
            let opts = Object.defineProperty({}, 'passive', {
                get: function () {
                    supported = true;
                },
            });
            window.addEventListener('testPassive', null, opts);
            window.removeEventListener('testPassive', null, opts);
        } catch (e) {}

        window.passiveListener = true;
        return supported;
    }

    /**
     * Check if a cms feature flag is active
     *
     * @param featureName
     * @returns {boolean}
     */
    static isActive(featureName) {
        return (
            CBS?.Registry?.Features?.hasOwnProperty(featureName) &&
            CBS.Registry.Features[featureName] === true
        );
    }
}
